<template>
  <RbuEditionPaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-rbut
    data-url="admin/rbu/edition/"
    data-key="editions"
    :extraParams="{ no_log: true }"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="rbu-edition-list"
  >
    <template v-slot:item.type="{ item }">
      <div>{{ $t(`rbu_edition.type_${item.type}`) }}</div>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <div v-if="item.status === 'DELETING'">
          <v-btn text color="primary" disabled>DELETING ...</v-btn>
        </div>
        <div
          v-else-if="item.status === 'NORMAL'"
          style="display: flex; flex-direction: row"
        >
          <v-btn
            v-if="item.updating_selected_rate === false"
            text
            color="primary"
            @click="editItem(item)"
          >
            Edit
          </v-btn>
          <v-btn
            v-if="item.importing_sor_into_rbu === false"
            text
            color="primary"
            @click="configureItem(item)"
          >
            Configure
          </v-btn>
          <v-btn
            text
            color="primary"
            v-if="canDeleteRbu(item)"
            @click="deleteItem(item)"
          >
            Delete
          </v-btn>

          <div v-if="item.importing_sor_into_rbu === true">
            <v-btn text color="primary" disabled
              >IMPORTING SOR INTO RBU...</v-btn
            >
          </div>
          <div v-if="item.updating_selected_rate === true">
            <v-btn text color="primary" disabled>UPDATING ITEM CONFIG...</v-btn>
          </div>
        </div>
        <div v-else-if="'CREATING'">
          <v-btn text color="primary" disabled>Creating Items ...</v-btn>
        </div>
      </div>
    </template>
  </RbuEditionPaginatedList>
</template>

<script>
import {
  onMounted,
  ref,
  watch,
  onUnmounted,
  computed,
} from "@vue/composition-api";
import RbuEditionPaginatedList from "../RbuEditionPaginatedList";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS, USER_TYPE } from "@/constants";

export default {
  name: "RbuEditionList",
  components: { RbuEditionPaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    let refreshInterval = null;

    const refresh = function () {
      innerRefreshTrigger.value = true;
    };

    onMounted(() => {
      refreshInterval = setInterval(() => {
        refresh();
      }, 10000);
    });

    onUnmounted(() => {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([
      { text: root.$t("rbu.edition"), value: "edition.id", contains: true },
    ]);

    // Data Table
    const headers = ref([
      { text: root.$t("rbu.edition"), value: "edition" },
      { text: root.$t("rbu.rbu_edition_name"), value: "name" },
      { text: "type", value: "type" },
      { text: "", value: "actions", sortable: false, width: 100 },
    ]);
    const innerRefreshTrigger = ref(false);

    const canDeleteRbu = function (item) {
      if (!item) return false;
      if (!root.$store.getters.account) return false;
      const result =
        root.$store.getters.hasPermission(PERMISSIONS.MANAGE_RBU_EDITION) &&
        item.importing_sor_into_rbu === false &&
        item.updating_selected_rate === false &&
        [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
          root.$store.getters.account.type
        );
      return result;
    };

    const editItem = async function (item) {
      root.$router.push({
        name: "rbu-edition-detail",
        params: { editionId: item.id },
      });
    };
    const configureItem = async function (item) {
      root.$router.push({
        name: "rbu-edition-configure",
        params: { editionId: item.id },
      });
    };
    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete RBU Edition?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/edition/delete/",
          params: { edition_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItem,
      configureItem,
      deleteItem,
      PERMISSIONS,
      canDeleteRbu,
    };
  },
};
</script>

<style lang="less"></style>
